<div class="modal-v2 update-email-modal">
  <div class="modal-v2-header">
    <div class="modal-v2-title">
      {{ 'update_email_modal.title' | translate }}
    </div>

    <button
      class="modal-v2-close"
      (click)="dialogRef.close({ type: state() === 'success' ? 'CONFIRM' : 'CANCEL' })"
    >
      <tc-icon iconType="close"></tc-icon>
    </button>
  </div>

  <form
    class="modal-v2-content"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
  >
    @if (state() === 'input') {
      <div class="form-control">
        <label
          class="form-label"
          for="email"
        >
          {{ 'update_email_modal.enter_new_email' | translate }}
        </label>

        <input
          class="form-input"
          [class.form-input-invalid]="isControlInvalid(form.controls.email)"
          [formControl]="form.controls.email"
          type="text"
          inputmode="email"
          id="email"
          placeholder="taras.shevchenko@gmail.com"
          appAutofocus
        >

        @if (isControlInvalid(form.controls.email)) {
          <div class="form-control-error">
            {{ 'global.required_field' | translate }}
          </div>
        }
      </div>

      @if (error()) {
        <div class="form__error">
          {{ error() }}
        </div>
      }
    } @else if (state() === 'otp') {
      <tc-otp
        [otpRequest]="otpRequest()"
        [otpDigitsFormArray]="form.controls.otpDigits"
        [isLoading]="isLoading()"
        [error]="error()"
        (submit)="onSubmit()"
        (resendOtp)="updateEmailInit()"
      />

      <button
        class="main-link go-back"
        [disabled]="isLoading()"
        (click)="goBackFromOtp()"
        type="button"
      >
        {{ 'global.back' | translate }}
      </button>
    } @else {
      <div class="success-header">
        {{ 'update_email_modal.success_header' | translate }}
      </div>
      <div class="success-text html-description">
        {{ 'update_email_modal.success_text' | translate }}
      </div>
    }

    @if (state() !== 'otp') {
      <tc-button
        class="form-submit"
        [isLoading]="isLoading()"
        [isDisabled]="isSubmitDisabled()"
        buttonType="submit"
        buttonSize="large"
      >
        @if (state() === 'input') {
          {{ 'global.confirm' | translate }}
        } @else {
          {{ 'global.done' | translate }}
        }
      </tc-button>
    }
  </form>
</div>
